import axios from "axios";
import {ENDPOINT_AUTH_INFOS, ENDPOINT_AUTH_LOGIN, ENDPOINT_AUTH_LOGOUT} from '@/constants/endpoints'
import AlertStore from '@/stores/AlertStore'
import SaveFormEntrepriseStore from "./SaveFormEntrepriseStore";
import SaveFormEntrepriseMarcheInfosStore from "./SaveFormEntrepriseMarcheInfosStore";
import devServer from '../../vue.config'
import {ENDPOINT_AUTH_LOGIN_SAML, ENDPOINT_AUTH_LOGOUT_SAML, ENDPOINT_AUTH_METHOD} from "../constants/endpoints";
import { bytesToBase64 } from "../utils/stringUtil";


let store = {
  debug: true,
  state: {
    authenticationMethod: null,
    authenticated: false,
    id: null,
    username: null,
    nom: null,
    prenom: null,
    email: null,
    lastLogin: null,
    roles: [],
    marches: [],
    marche: null
  },


  isAuthenticated() {
    return this.state.authenticated
  },
  disconnect() {
    if (this.state.authenticationMethod === 'SSO') {
      this.logoutSaml();
    } else {
      return axios
          .get(ENDPOINT_AUTH_LOGOUT)
          .then(() => true)
          .catch(error => {
            AlertStore.pushError(error.response.data.message);
          })
    }
  },
  doAuthentication(username, password) {
    let basicAuth = 'Basic ' + bytesToBase64(new TextEncoder().encode(username + ':' + password));
    return axios
        .post(ENDPOINT_AUTH_LOGIN, {},{
          headers: { 'Authorization': basicAuth }
        })
        .then(response => {
          this.setInfos(response.data);
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },
  loginSaml() {
    const HOST = devServer.devServer.proxy["^/rse"].target;
    window.location.href = `${HOST}${ENDPOINT_AUTH_LOGIN_SAML}`;
  },
  logoutSaml() {
    const HOST = devServer.devServer.proxy["^/rse"].target;
    window.location.href = `${HOST}${ENDPOINT_AUTH_LOGOUT_SAML}`;
  },
  authenticationMethod() {
    return axios.get(ENDPOINT_AUTH_METHOD);
  },

  // Used only once during the initialization stage of the application
  init() {
    return this.authenticationMethod().then(
        value => {
          this.state.authenticationMethod = value.data;
          return axios.get(ENDPOINT_AUTH_INFOS)
              .then(response => {
                this.setInfos(response.data);
                return true;
              })
              .catch(e => {
                console.log(e);
                this.state.authenticated = false;
                return false;
              })
        },
        error => console.log(error));
  },
  setInfos(authInfos) {
    this.state.id = authInfos.id;
    this.state.username = authInfos.username;
    this.state.nom = authInfos.nom;
    this.state.prenom = authInfos.prenom;
    this.state.email = authInfos.email;
    this.state.lastLogin = authInfos.lastLogin;
    this.state.roles = authInfos.roles;
    this.state.marches = authInfos.marches;
    this.state.marche = authInfos.marches && authInfos.marches[0] ? authInfos.marches[0] : null;
    this.state.authenticated = true;
  },
  resetInfos() {
    this.state.id = null;
    this.state.username = null;
    this.state.nom = null;
    this.state.prenom = null;
    this.state.email = null;
    this.state.lastLogin = null;
    this.state.roles = [];
    this.state.marches = [];
    this.state.marche = null;
    this.state.authenticated = false;
    SaveFormEntrepriseStore.clear();
    SaveFormEntrepriseMarcheInfosStore.clear();
  }
};

export default store;
